import {
  ACTION_FAILURE_HANDLE,
  ACTION_SUCCESS_HANDLE,
  COLLECT_RECEIVED_HANDLE,
  CONDITION_FALSE_HANDLE,
  CONDITION_TRUE_HANDLE,
  FALLBACK_HANDLE,
  INVOKE_COMPLETED_HANDLE,
  LINEAR_HANDLE,
  PALETTE,
  TIMEOUT_HANDLE,
  inferWorkflowTypeFromNode,
  isMapTransitionPalette,
  isWhatsappPalette,
  supportsTimeoutRef,
  usesOnSuccessRef,
  usesTransitions
} from "./workflowPaletteConstants";

export function getButtonOptionIds(config) {
  return (config?.message?.options || []).map((option) => option.id).filter(Boolean);
}

export function getListItemIds(config) {
  const items = config?.message?.items;
  if (!Array.isArray(items)) return [];
  return items.map((item) => item.id).filter(Boolean);
}

function withTimeoutHandle(workflowType, handles) {
  return supportsTimeoutRef(workflowType) ? [...handles, TIMEOUT_HANDLE] : handles;
}

/** Source handle ids for a palette node (used by CustomNodes). */
export function getSourceHandleIds(nodeData) {
  const paletteType = nodeData?.paletteType;
  const workflowType =
    nodeData?.workflowType ||
    inferWorkflowTypeFromNode({
      type: nodeData?.workflowType,
      paletteType: nodeData?.paletteType,
      config: nodeData?.config
    });
  const config = nodeData?.config || {};

  if (usesOnSuccessRef(workflowType)) {
    return [ACTION_SUCCESS_HANDLE];
  }

  if (workflowType === "CONDITION") {
    return [CONDITION_TRUE_HANDLE, CONDITION_FALSE_HANDLE];
  }

  if (workflowType === "ACTION" || paletteType === PALETTE.ACTION) {
    if (config.action === "HTTP_REQUEST") {
      return [ACTION_SUCCESS_HANDLE, ACTION_FAILURE_HANDLE];
    }
    if (config.action === "CLOSE_CONVERSATION") {
      return [];
    }
    return [ACTION_SUCCESS_HANDLE];
  }

  if (workflowType === "END") {
    return [];
  }

  if (workflowType === "COLLECT_INPUT") {
    return withTimeoutHandle(workflowType, [COLLECT_RECEIVED_HANDLE]);
  }

  if (workflowType === "INVOKE_WORKFLOW") {
    return [INVOKE_COMPLETED_HANDLE];
  }

  if (workflowType === "HANDOFF" || workflowType === "TRANSFER_WORKFLOW") {
    return [];
  }

  if (isMapTransitionPalette(paletteType, config)) {
    const isButtons = /\.buttons(\.|$)/.test(paletteType) ||
      (paletteType === "whatsapp.await" && config?.message?.type === "buttons");
    const optionIds = isButtons
      ? getButtonOptionIds(config)
      : getListItemIds(config);
    if (optionIds.length === 0) {
      return [];
    }
    return withTimeoutHandle(workflowType, optionIds);
  }

  if (isWhatsappPalette(paletteType) && usesTransitions(workflowType)) {
    return withTimeoutHandle(workflowType, [LINEAR_HANDLE]);
  }

  if (isWhatsappPalette(paletteType)) {
    return [LINEAR_HANDLE];
  }

  return [LINEAR_HANDLE];
}

export function getSourceHandleLabel(handleId, nodeData) {
  if (handleId === CONDITION_TRUE_HANDLE) return "TRUE";
  if (handleId === CONDITION_FALSE_HANDLE) return "FALSE";
  if (handleId === ACTION_SUCCESS_HANDLE) return "OK";
  if (handleId === ACTION_FAILURE_HANDLE) return "FAIL";
  if (handleId === FALLBACK_HANDLE) return "Other";
  if (handleId === COLLECT_RECEIVED_HANDLE) return "IN";
  if (handleId === INVOKE_COMPLETED_HANDLE) return "DONE";
  if (handleId === TIMEOUT_HANDLE) return "Timeout";
  if (handleId === LINEAR_HANDLE) return "→";

  const config = nodeData?.config || {};
  const paletteType = nodeData?.paletteType;

  if (isMapTransitionPalette(paletteType, config)) {
    const isButtons = /\.buttons(\.|$)/.test(paletteType) ||
      (paletteType === "whatsapp.await" && config?.message?.type === "buttons");
    if (isButtons) {
      const option = (config.message?.options || []).find((row) => row.id === handleId);
      if (option?.label) return option.label;
    } else {
      const item = (config.message?.items || []).find((row) => row.id === handleId);
      if (item?.label || item?.title) return item.label || item.title;
    }
  }

  return handleId;
}
